// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum Status {
  HighSpeedStartSequence = 0,
  RunningHighSpeed = 1,
  MGRequest = 2,
  LoadWeightDispatch = 3,
  DrvMgDriveOn = 4,
  PowerUpSequence = 5,
  DriveFaultOccured = 6,
  Power = 7,
  Safety = 8,
  FrontPhotoCellBroken = 9,
  RearPhotoCellBroken = 10,
  GateLock = 11,
  NoDemand = 12,
  HatchAccess = 13,
  CarTimedOut = 14,
  CarNotLoaded = 15,
  FrontDoorOpenButton = 16,
  FrontDoorCloseButton = 17,
  FrontSafetyEdgeActivated = 18,
  RearSafetyEdgeActivated = 19,
  RearDoorOpenButton = 20,
  RearDoorCloseButton = 21,
  HallShutdownSwitch = 22,
  CarShutdownSwitch = 23,
  Derailment = 24,
  PowerLimit1 = 25,
  PowerLimit2 = 26,
  ReducedSpeed = 27,
  DispatcherDown = 28,
  CarStopSwitchUp = 29,
  CarStopSwitchOpen = 30,
  CounterweightDerailment = 31,
  Earthquake = 32,
  HallIndependent = 33,
  MassMedical = 34,
  EmergencyPower = 35,
  Lock = 36,
  CarGateLocked = 37,
  SafetySwitchOpen = 38,
  SafetyStringClosed = 39,
  SafetyStringOpen = 40,
  StopSwitch = 41,
  HOCarRAndControllerSSUP = 42,
  ContinuousOperation = 43,
  Delta = 44,
  DirChangeOperation = 45,
  EngineerOnSite = 46,
  HighSpeedOperation = 47,
  Local = 48,
  Mains = 49,
  ROIN = 50,
  RSIN = 51,
  RSKMFailure = 52,
  Ready = 53,
  RegulatedOperation = 54,
  RemoteOperation = 55,
  StarOperation = 56,
  TPWR = 57,
  PowerBackUp = 58,
  PowerGenerator = 59,
  Auto = 60,
  PitFlood = 61,
  MotorThermalTOL = 62,
  SwingCar = 63,
  UpHighSpeed = 64,
  UpFloorSeek = 65,
  UpSlowSpeed = 66,
  UpLeveling = 67,
  DownHighSpeed = 68,
  DownFloorSeek = 69,
  DownSlowSpeed = 70,
  DownLeveling = 71,
  AutoDoorEnabled = 72,
  CarReset = 73,
  CodeBlueReturn = 74,
  DBResistorTempError = 75,
  DoorLockBottom = 76,
  DoorLockMiddle = 77,
  DoorLockTop = 78,
  ElectricEye = 79,
  EmergencyPowerRecall = 80,
  FaultedOutOfService = 81,
  FirePhase1 = 82,
  RearDoorLockMiddle = 83,
  RearElectricEye = 84,
  SF_DBR = 85,
  SF_DCL = 86,
  SF_DRV = 87,
  SF_GDL = 88,
  SF_GRP = 89,
  SF_IO = 90,
  SF_NGL = 91,
  SF_RDY = 92,
  SF_SPB = 93,
  SF_STP = 94,
  SafetyEdge = 95,
  WaitingForDoorClosed = 96,
  AnualSafetyTest = 97,
  BinaryPositionInputError = 98,
  BrakeLiftSwitchError = 99,
  DoorZoneFault = 100,
  DownLevelInput = 101,
  EmergencyPowerSelToRun = 102,
  InspOrLockBypassFault = 103,
  NoAutomaticDoors = 104,
  NoHCPower = 105,
  NoLCPower = 106,
  NoPotentialInput = 107,
  NoSSInput = 108,
  PositionError = 109,
  TopOffCarrCommunicationError = 110,
  UpLevelInput = 111,
  sf_ShD = 112
}
